// extracted by mini-css-extract-plugin
export default {"content":"content__UJb7A","content__iframe":"content__iframe__WIgTZ","content__iframe__loader":"content__iframe__loader__RkviK","titleHead":"titleHead__EILIh"};